
import { useSelector } from 'react-redux';
import ReadFullPolicyModel from '../model/ReadFullPolicyModel';

const HandleReadFullPolicyModel = () => {
    const openReadFullPolicy = useSelector(
    (state: { modal: { readFullPolicyModel: boolean } }) => state.modal.readFullPolicyModel
  );
  return (
    <>
      {openReadFullPolicy && <ReadFullPolicyModel />}
    </>
  )
}

export default HandleReadFullPolicyModel
